module.exports = __webpack_public_path__ + "img/Read.68d5bc9.svg";